import { Tag } from "components/DesignSystem/Tag/Tag";
import { Task1120Tracker } from "types/Models/TaskTracker";

const shortName = (name: string): string =>
  name
    .replace(/^Form /, "")
    .replace(/ #\d+$/, "")
    .trim();

export const SubFilings = ({ row }: { row: Task1120Tracker }) => {
  if (!row.sub_filings || row.sub_filings.length === 0) {
    return <span className="t-text-text-30">-</span>;
  }

  return (
    <div className="t-flex t-flex-wrap t-gap-1">
      {row.sub_filings.map((filing) => (
        <Tag
          key={filing.task_uuid}
          icon={false}
          tagType="gray"
          rounded
          size="small"
        >
          {shortName(filing.name)}
        </Tag>
      ))}
    </div>
  );
};
